import RouteTemplate from 'ember-route-template'
import type { TOC } from '@ember/component/template-only'
import { SiteHeader } from 'district-ui-client/components/site-header'
import { SideNav } from 'district-ui-client/components/side-nav'
import type SubscriptionTypeRoute from 'district-ui-client/subscription-type/route'

interface Signature {
  Args: {
    model: ModelFor<SubscriptionTypeRoute>
  }
}

export const SubscriptionTypePage: TOC<Signature> = <template>
  <SiteHeader />
  <SideNav class="min-h-0 flex-shrink flex-grow" @subscriptionType={{@model.subscriptionType}}>
    {{outlet}}
  </SideNav>
</template>

export default RouteTemplate(SubscriptionTypePage)
